import '../stylesheets/application.css'
import { createApp } from 'vue'
import TrackingsTable from '../components/TrackingsTable.vue'

// Mount Vue component on page if container exists
document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('vue-trackings-table')

  if (container) {
    const app = createApp(TrackingsTable, {
      apiUrl: container.dataset.apiUrl || '/trackings',
      canEdit: container.dataset.canEdit === 'true',
    })

    app.mount(container)
  }
})
